import React, { useCallback, useEffect } from "react";
import { Paths } from "../../../../Paths";
import { AddButton } from "../../common/button/AddButton";
import { getServiceProviderListAction } from "../../../../state/usecase/admin/service_provider/actions";
import { useAppDispatch } from "../../../../state/store";
import { ServiceProviderList } from "./list/ServiceProviderList";
import { useNavigate } from "react-router-dom";

export function AdminServiceProviderListPage() {
    const navigate = useNavigate();

    const dispatch = useAppDispatch();

    useEffect(() => {
        dispatch(getServiceProviderListAction());
    }, [dispatch]);

    const handleServiceProviderAddClicked = useCallback(() =>
        navigate(`${Paths.admin}${Paths.serviceProvider}${Paths.add}`)
    , [history]);

    return (
        <div className={"service_provider_list_page"}>
            <div className={"container"}>
                <p className={"header"}>事業者一覧</p>
                <ul className={"service_provider_list"}>
                    <ServiceProviderList />
                </ul>
                <div className="row" onClick={handleServiceProviderAddClicked}>
                    <AddButton label="事業者を追加する" onClick={handleServiceProviderAddClicked}/>
                </div>
            </div>
        </div>
    );
}
